module.exports = __webpack_public_path__ + "distribution/img/kong.fdcd02df.png";